import React from "react";
import cn from "classnames";

import Icon from "../Icon";

type Props = {
  title?: string;
  className?: string;
  type?: "user" | "business";
  icon?: string;
  iconColor?: string;
  onClick?: (e: React.MouseEvent<HTMLDivElement>) => void;
  onBlur?: (e: React.FocusEvent<HTMLDivElement>) => void;
};

export const Avatar: React.FC<Props> = (props) => {
  const {
    title,
    className,
    type = "user",
    icon,
    iconColor,
    onClick,
    onBlur = (): void => undefined,
  } = props;

  const letter = title?.charAt(0).toUpperCase();

  return (
    <div
      className={cn("avatar-base relative", className, {
        "bg-purple-50 border-purple-500 text-purple-500": type === "user",
        "bg-green-50 border-green-500 text-green-500": type === "business",
        "cursor-pointer": onClick,
      })}
      onClick={onClick}
      onBlur={onBlur}
    >
      {letter}

      {icon && (
        <div className="absolute bottom-0 right-0 transform translate-x-1 translate-y-1">
          <div
            className={cn(
              "flex flex-row items-center justify-center rounded-full h-6 w-6",
              `${iconColor?.replace("text", "bg")}`
            )}
          >
            <Icon icon={icon} size={18} className="text-white" />
          </div>
        </div>
      )}
    </div>
  );
};
